module.exports = __webpack_public_path__ + "0a4ce54c228b2079e7e97b8f0c851f29.png";